// swiper実行
// --- 最新のswiper v11ではループ時の不具合があるため、あえてv8を使用
document.addEventListener('DOMContentLoaded', function () {

  // swiper PC3つ並び / TB2つ並び / SP1つ
  if (document.querySelector('.js-slider')) {
    const swiper = new Swiper(".js-slider", {
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      slidesPerView: "auto",
      spaceBetween: 20,
      centeredSlides: true,

      // ブレークポイント（画面幅による設定）
      breakpoints: {
        // 画面幅が 768px 以上の場合（window width >= 768px）
        768: {
          spaceBetween: 50
        }
      },
      pagination: {
        el: ".js-slider .swiper-pagination",
      },
      navigation: {
        nextEl: ".js-slider .swiper-button-next",
        prevEl: ".js-slider .swiper-button-prev",
      },
    });

  }

})